import React from "react"

export default function Ellipse({ className }: any) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.64" cx="12" cy="12" r="12" fill="#2F2F2F" fillOpacity="0.46" />
    </svg>
  )
}
